import api from './api';

// Properties, and the two ways to get applicants for one: an application link, or a personal invitation.
const propertyService = {
  list: async (organisationId) => (await api.get(`/organisations/${organisationId}/properties`)).data,
  get: async (id) => (await api.get(`/properties/${id}`)).data,
  create: async (organisationId, data) => (await api.post(`/organisations/${organisationId}/properties`, data)).data,
  update: async (id, data) => (await api.put(`/properties/${id}`, data)).data,
  remove: async (id) => (await api.delete(`/properties/${id}`)).data,

  uploadMandate: async (id, file) => {
    const form = new FormData();
    form.append('mandate', file);
    return (await api.post(`/properties/${id}/mandate`, form, { headers: { 'Content-Type': 'multipart/form-data' } })).data;
  },

  // The owner can read back the proof of authority they uploaded.
  mandateDocument: async (id) => (await api.get(`/properties/${id}/mandate/download`, { responseType: 'blob' })).data,

  // Shareable link / QR code
  applyLink: async (id) => (await api.get(`/properties/${id}/apply-link`)).data,
  enableApplyLink: async (id) => (await api.post(`/properties/${id}/apply-link`)).data,
  disableApplyLink: async (id) => (await api.delete(`/properties/${id}/apply-link`)).data,

  // Invite one named person: create the application, then email them a personal link.
  inviteApplicant: async (organisationId, propertyId, applicant) => {
    const application = (await api.post(`/organisations/${organisationId}/applications`, { property_id: propertyId })).data;
    await api.post(`/applications/${application.id}/invitations`, {
      applicant_email: applicant.email,
      applicant_first_name: applicant.first_name || undefined,
      applicant_last_name: applicant.last_name || undefined
    });
    return application;
  }
};

export default propertyService;
